import gmail_logo from '../assets/gmail.webp'
import linkedin_logo from '../assets/linkedin.svg'
import phone_logo from '../assets/phone.png'
import github_logo from '../assets/github.svg'
export const contacts = [
    {
        id:1,
        name:'E-Mail',
        value:'shokouhi.erfan75@gmail.com',
        type:'mail',
        logo:gmail_logo,
    },
    {
        id:2,
        name:'Phone',
        value:'+989128997968',
        type:'phone',
        logo:phone_logo
    },
    {
        id:3,
        name:'LinkedIn',
        value:'https://www.linkedin.com/in/erfanshk/',
        type:'link',
        logo:linkedin_logo,
    },
    {
        id:3,
        name:'GitHub',
        value:'https://github.com/erfanshk/',
        type:'link',
        logo:github_logo,
    },
]